
import { defineComponent } from 'vue'
import { useQuery, useResult } from '@vue/apollo-composable'
import TheMainHeader from '@/common/components/TheMainHeader.vue'
import { GET_USER_QUERY } from '@/services/apollo/requests'
import { GraphQLUserData } from '@/services/apollo/types'

export default defineComponent({
    name: 'Patreon',
    components: {
        TheMainHeader,
    },
    setup() {
        const { result, loading } = useQuery(GET_USER_QUERY)

        const isPatron = useResult(
            result,
            false,
            (data: GraphQLUserData) => data.getUserData?.patreonStatus?.isPatron
        )

        const name = useResult(
            result,
            '',
            (data: GraphQLUserData) =>
                data.getUserData?.patreonStatus?.patreonName
        )

        const totalPledged = useResult(
            result,
            '',
            (data: GraphQLUserData) =>
                Number(data.getUserData?.patreonStatus?.lifetimePledgeCents) /
                100
        )

        return {
            loading,
            isPatron,
            name,
            totalPledged,
        }
    },
})
